export const Marks = ({data, xScale, yScale, colorScale, xValue, yValue, colorValue, circleRadius, className}) =>
  data.laps.map((d) => (
    <circle
      className={className}
      cx={xScale(xValue(d))}
      cy={yScale(yValue(d))}
			r={circleRadius}
      fill={colorScale(colorValue(data))}
    >
    </circle>
  ));
